import * as React from 'react';

import Button from 'basics/buttons/Button';

import { Container, ErrorState } from './ContentPlaceholder.styled';

type Props = {
    label?: string;
    children?: React.ReactNode;
    error?: string;
    onRetry?: () => void;
    compact?: boolean;
};

const ContentPlaceholder = ({
    label = 'Loading content',
    children,
    error,
    onRetry,
    compact,
}: Props) => (
    <Container role={error ? 'alert' : 'status'} aria-label={error || label}>
        {error ? (
            <ErrorState $compact={compact}>
                <p>{error}</p>
                {onRetry && <Button onClick={onRetry}>Try again</Button>}
            </ErrorState>
        ) : (
            children
        )}
    </Container>
);

export default ContentPlaceholder;
